import { render, staticRenderFns } from "./SupportChatSidebar.vue?vue&type=template&id=75dafa63&scoped=true&"
import script from "./SupportChatSidebar.vue?vue&type=script&lang=js&"
export * from "./SupportChatSidebar.vue?vue&type=script&lang=js&"
import style0 from "./SupportChatSidebar.vue?vue&type=style&index=0&id=75dafa63&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75dafa63",
  null
  
)

export default component.exports